import {Chip, Stack, Typography, useTheme} from "@mui/joy"
import {ShieldCheck} from "lucide-react"
import AuthForm from "../components/AuthForm"
import Card from "../components/Card"
import FullLogo from "../components/Logo"
import {activePalette, applyTransparency} from "../theme"

/**
 * Full page sign in.
 *
 * Most of the app asks for an account through the dialog, without leaving the screen; this page is
 * what a direct link to /auth, a bookmark or a shared invitation lands on.
 */
const Auth = () => {
    const theme = useTheme()
    const palette = activePalette(theme)

    return <Stack minHeight={"100dvh"} alignItems={"center"} justifyContent={"center"} padding={2}
                  sx={{
                      backgroundColor: "#050e1c",
                      backgroundImage: `radial-gradient(circle at 15% 0%, ${applyTransparency(palette.primary["500"], 0.35)}, transparent 45%),
                                        radial-gradient(circle at 85% 100%, ${applyTransparency(palette.primary["400"], 0.3)}, transparent 45%)`
                  }}>
        <Stack gap={3} width={"100%"} maxWidth={"27rem"} paddingY={4}>
            <Stack alignItems={"center"} gap={1}>
                <FullLogo/>
                <Typography level={"body-sm"} textAlign={"center"} textColor={"text.tertiary"}>
                    Sign in to analyse matches and track your predictions
                </Typography>
            </Stack>

            <Card>
                <AuthForm/>
            </Card>

            <Stack direction={"row"} alignItems={"center"} justifyContent={"center"} gap={1}>
                <Chip size={"sm"} variant={"soft"} startDecorator={<ShieldCheck size={14}/>}>
                    Secured by Firebase
                </Chip>
            </Stack>
        </Stack>
    </Stack>
}

export default Auth
